/**************************************************
 * Nombre:       Formulario_Sectores
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {CategoryOutlined, LocalShippingOutlined} from "@mui/icons-material";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";

const Formulario_Sectores = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <IngresoTexto Icono={CategoryOutlined} nombre={'Nombre de Sector'}
                                  dato={'nombre'} {...props}
                                  requerido={'El Nombre es requerido'}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={LocalShippingOutlined} nombre={'Valor Envio 1 Kilo'}
                                   dato={'valor'} {...props}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={LocalShippingOutlined} nombre={'Valor Envio Gratis'}
                                  dato={'valorGratis'} {...props}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Sectores